import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app';
import vuefire 			from "@/firebase/vuefire"
import user_fct from '@/firebase/user'
import Home           from '@/views/Home.vue'
import Bientot           from '@/views/Bientot.vue'
import Club           from '@/views/club/index.vue'
import viewClub           from '@/views/club/viewClub.vue'
import Tournois       from '@/views/tournoi/index.vue'
import Season       from '@/views/season/index.vue'
import Membres        from '@/views/joueurs/listMembres.vue'
import Demandes        from '@/views/club/adhesion/listDemandes.vue'
import inviteClub   from '@/views/club/inviteClub.vue'
import participeTournoi   from '@/views/club/participeTournoi.vue'
import LoginJustEmail from '@/views/auth/LoginJustEmail.vue'

import ClassementSaison from '@/views/season/classement.vue'

import InstagramAuth from '@/views/InstagramAuth.vue'
import Profil from '@/views/profil/index.vue'
import checkout from '@/views/payment/checkout.vue'
import configureHelp from '@/views/help/configure.vue'
import invite from '@/views/auth/invite.vue'
import ErrorPath from '@/Error.vue'
import listTournoi from '@/views/tournoi/list/listTournoi.vue'
import myTournoi from '@/views/myTournoi/index.vue'
import verified from '@/views/auth/verified.vue'
import test           from '@/views/test.vue'
import testPool           from '@/views/testPool.vue'
import testImg           from '@/views/testImg.vue'
import testoffline from '@/views/testoffline.vue'
import console from '@/views/admin/console.vue'
import stat from '@/views/admin/stat.vue'
import tuto from '@/views/admin/adminTuto.vue'
import notAutoriserTest from '@/views/admin/notAuthoriseTest.vue'
import firebase_api from "@/firebase/firebase_api"; 

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  
  routes: [
    {
      path: '/notAutoriseTest',
      name: 'notAutoriseTest',
      component: notAutoriserTest,
      meta: {
        notAutoriser: true
      }
    },
    {
      path: '/helpConfigure',
      name: 'configureHelp',
      component: configureHelp,
      meta: {
        navbar: true,
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/console',
      name: 'console',
      component: console,
      meta: {
        navbar: true,
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/stat',
      name: 'stat',
      component: stat,
      meta: {
        navbar: true,
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/tuto',
      name: 'tuto',
      component: tuto,
      meta: {
        navbar: true,
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/verified',
      name: 'verified',
      component: verified,
      meta: {
        navbar: true
      }
    },
    {
        path: '/visit',
        name:'visit',
        component: listTournoi,
        meta: {
          navbar: false
        }
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        navbar: false
      }
    },
    {
      path: '*',
      name: 'home',
      component: Home,
      meta: {
        navbar: false
      }
    },
    
    {
      path: '/invite/:id',
      name: 'invite',
      component: invite
    },
    {
      path: '/testPool',
      name: '/testPool',
      component: testPool
    },
    {
      path: '/testImg',
      name: '/testImg',
      component: testImg
    },
    {
      path: '/invitclub/:id/:email/:club',
      name: 'invitClub',
      component: inviteClub,
      meta: {
        requiresAuth: false,
        navbar: false,
        idClubExist: false,
        anonyme: true,
        visiteur: true,
        player: true
      }
    },
    {
      path: '/participeTournoi/:club/:id/:idTournoi/:email/:participe',
      name: 'participeTournoi',
      component: participeTournoi,
      meta: {
        requiresAuth: false,
        navbar: false,
        idClubExist: false,
        anonyme: true,
        visiteur: true,
        player: true
      }
    },
    {
      path: '/club/:id/saisons',
      name: 'saison',
      component: Season,
      meta: {
        requiresAuth: true,
        navbar: true,
        idClubExist: true,
        anonyme: true,
        visiteur: true,
        player: true
      }
    },
    {
      path: '/club/:id/saisons/:idSeason/classement',
      name: 'classementSeason',
      component: ClassementSaison,
      meta: {
        requiresAuth: true,
        navbar: true,
        idClubExist: true,
        anonyme: true,
        visiteur: true,
        player: true
      }
    },
    {
      path: '/testoffline',
      name: '/testoffline',
      component: testoffline
    },
    {
      path: '/club/:id/myTournoi/:idTournoi',
      name: 'myTournoi',
      component: myTournoi,
      meta: {
        requiresAuth: true,
       
        idClubExist: true,
        anonyme: false,
        visiteur: false,
        player: true
      }
    },
    
    {
      path: '/payment',
      name: "payment",
      component: checkout,
      meta: {
        requiresAuth: true,
        navbar: true,
        anonyme: false
      }
    },
    {
      path: '/club/:id/payment',
      name: "paymentWithClub",
      component: checkout,
      meta: {
        requiresAuth: true,
        navbar: true,
        idClubExist: true,
        anonyme: false,
        visiteur: false,
        player: false
      }
    },
    {
      path: '/MesClubs',
      name: 'club',
      component: Club,
      meta: {
        requiresAuth: true,
        navbar: true
      }
    },
   
    {
      path: '/club/:id',
      name: 'viewClub',
      component: viewClub,
      meta: {
        navbar: true,
        anonyme: true,
        requiresAuth: true,
        idClubExist: true,
        visiteur: true,
        player: true
      }
    },
    {
      path: '/club/:id/concours',
      name: 'concours',
      component: Tournois,
      meta: {
        requiresAuth: true,
        navbar: true,
        idClubExist: true,
        anonyme: true,
        visiteur: true,
        player: true
      }
    },
    {
      path: '/club/:id/saisons/:idSeason/tournois',
      name: 'tournoisSeason',
      component: Tournois,
      meta: {
        requiresAuth: true,
        navbar: true,
        idClubExist: true,
        visiteur: true,
        player: true,
        anonyme: true
      }
    },
    {
      path: '/club/:id/membres',
      name: 'membres',
      component: Membres,
      meta: {
        requiresAuth: true,
        navbar: true,
        idClubExist: true,
        anonyme: false,
        visiteur: false,
        player: false,
        tuto: true
      }
    },
    {
      path: '/club/:id/demandes',
      name: 'demandes',
      component: Demandes,
      meta: {
        requiresAuth: true,
        navbar: true,
        idClubExist: true,
        anonyme: false,
        visiteur: false,
        player: false
      }
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorPath
    },
    {
      path: '/profil',
      name: 'profil',
      component: Profil,
      meta: {
        requiresAuth: true,
        navbar: true
    
      }
    },
    {
      path: '/club/:id/profil',
      name: 'profilWithClub',
      component: Profil,
      meta: {
        requiresAuth: true,
        navbar: true,
        idClubExist: true
      }
    },
    {
      path: '/instagramauth',
      name: 'instagramauth',
      component: InstagramAuth
    },
    {
      path: '/test',
      name: 'test',
      component: test
    }
  ]
});
function goHome(to, from, next, anonymeUser) {
  if (anonymeUser)
    firebase
    .auth()
    .signOut()
    .then(() => {
        vuefire.store.dispatch('init',()=>{
        next({name: "home"});
      })
    })
  else
    next({name: "home"});
}
router.beforeEach(async (to, from, next) => {

  const currentUser = firebase.auth().currentUser;
  var anonymeUser;
  if (currentUser != null)
     anonymeUser = currentUser.email == "anonyme@petanque-app.com"
  else
     anonymeUser = false;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const idClubExist =  to.matched.some((record) => record.meta.idClubExist);
  const anonyme = to.matched.some((record) => record.meta.anonyme);
  const visiteur = to.matched.some((record) => record.meta.visiteur);
  const player = to.matched.some((record) => record.meta.player);
  const adminMeta = to.matched.some((record) => record.meta.admin);
  const notAutoriser = to.matched.some((record) => record.meta.notAutoriser);
  const tuto = to.matched.some((record) => record.meta.tuto);
  var tutoActif = false;
  if (tuto)
    tutoActif = vuefire.store.getters.getDemo.active;
  await vuefire.store.dispatch('setDemo', {demo: false});
  if (notAutoriser) {
      next();
  }
  else if (!anonyme && requiresAuth && anonymeUser && !tuto) {
   
    goHome(to, from, next, anonymeUser);
  }
  else if (requiresAuth && currentUser) {
   
    if ( vuefire.store.getters.getUser == null) {
      // on initialise le store USER (du coup les clubs aussi)
      // normalement que la première fois
      await vuefire.store.dispatch('init', ()=>{
          // on regarde d'abord si le le user est est owner du club ou pas
      });
    }
    let userIsTest = typeof(vuefire.store.getters.getUser.test)=="undefined" 
    && firebase_api.keys.config.projectId=="petanktest-966f4"
    userIsTest = false
    if (userIsTest) {
      next({name: 'notAutoriseTest'})
    }
    else if (!currentUser.emailVerified && !anonymeUser) {
        next({name: "verified"});
    }
    else if (idClubExist) {
     
          var continueVerif = true;
         
          if (typeof(vuefire.store.getters.getUser.adminSite) != "undefined") {
            if (vuefire.store.getters.getUser.adminSite) {
                await vuefire.store.dispatch('setRole', {role: "owner"});
                continueVerif = false;
                next();
            }
          }
          if (continueVerif) {
             
              var idClub = to.params.id;
              var clubsAdminOrOwner = vuefire.store.getters.getMyClubs;
              var findAdminOrOwner = false;
              var indexAdminOrOwner = clubsAdminOrOwner.findIndex(clubItem=>{
                if (typeof(clubItem)!="undefined")
                    return clubItem.id == idClub
                else
                  return false
              });
              if (indexAdminOrOwner!=-1) {
                // Si il a trouvé c'est qu'il est soit owner ou admin
               
                var userInclubAdminOrOwner = clubsAdminOrOwner[indexAdminOrOwner].users[currentUser.uid];
              
                if (typeof(userInclubAdminOrOwner)!="undefined") {
                    findAdminOrOwner = true;
                    await vuefire.store.dispatch('setRole', {role: userInclubAdminOrOwner.role});
                    if (userInclubAdminOrOwner.role=="owner") {
                        if (clubsAdminOrOwner[indexAdminOrOwner].demo) {
                          if (vuefire.store.getters.getDemo.tutoriel == null) {
                            goHome(to, from, next, anonymeUser);
                          }
                          else
                            await vuefire.store.dispatch('setDemo', {demo: true});
                        }
                    }
                    next();
                }
              }
              if (!findAdminOrOwner) {
                  // Si on ne l'a pas trouvé c'est peut être un joueur
                  // on va regarder dans USER si le club exist ou pas
                  // Si on le retourve alors c'est un PLAYER

                  var indexClubsPlayer = vuefire.store.getters.getUser.clubs.findIndex(clubItem=>{
                      if (typeof(clubItem)!="undefined")
                          return clubItem.idClub == idClub
                      else
                        return false
                  });
                  if (indexClubsPlayer!=-1) {
                      if (player) {
                        var clubUser = vuefire.store.getters.getUser.clubs[indexClubsPlayer];
                        if (typeof(clubUser.invites)=="undefined")
                            await vuefire.store.dispatch('setRole', {role: "player"});
                        else
                            await vuefire.store.dispatch('setRole', {role: "invite"});
                        next();
                      }
                      else
                        goHome(to, from, next, anonymeUser);
                  }
                  else {
                        // Si il n'y est pas il faut vérifier si le club est public ou pas
                        // si il est public alors il peut devenir visiteur sinon il n'y a pas accès
                        var docClub = await firebase.firestore().collection("club").doc(idClub).get();
                        if (docClub.exists) {
                            if (docClub.data().public && visiteur) {
                              await vuefire.store.dispatch('setRole', {role: "visiteur"});
                              next();
                            }
                            else
                              goHome(to, from, next, anonymeUser);
                        }
                        else {
                          goHome(to, from, next, anonymeUser);
                        }
                  }
              }
            }
        } else {
          if (adminMeta) {
            if ( vuefire.store.getters.getUser == null) {
              // on initialise le store USER (du coup les clubs aussi)
              // normalement que la première fois
              await vuefire.store.dispatch('init', ()=>{
                  // on regarde d'abord si le le user est est owner du club ou pas
              });
            }
            if (typeof(vuefire.store.getters.getUser.adminSite) != "undefined") {
              if (vuefire.store.getters.getUser.adminSite) 
                next();
              else
                goHome(to, from, next, anonymeUser);
            }
            else
              goHome(to, from, next, anonymeUser);
        }
        else
          next()      
        }  
    
  }
  else  if (requiresAuth && !currentUser) {
   
   
    if (anonyme) {
      next({name: "invite", params: { id: to.params.id}})  
    } 
    else
      goHome(to, from, next, anonymeUser);
  }  else {
    
    next();
  }
});
/*
firebase.auth().signInAnonymously()
      .then(() => {
        vuefire.store.dispatch('init', ()=>{
          next()
        })
      })
      .catch((error) => {
        var errorCode = error.code;
        var errorMessage = error.message;
        // ...
      });
      vuefire.store.dispatch('init', ()=>{
                if (vuefire.store.getters.getUser == null) 
                  next()
                else
                  next("club");
              })
      */
export default router;